import { TextInput } from 'components/atoms/TextInput';
import { media, styled } from '@nx-kit/styling';

export const WrapperRBPayment = styled.div`
  > * {
    display: flex;
    padding-top: 14px;

    &:first-child {
      padding-top: 0;
    }
  }
`;

export const SortGroupWithSpaceStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const DateGroupStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;

  > * {
    width: 100%;
    ${media('md')} {
      width: 45%;
    }
  }

  div div button {
    height: 57px;
  }
`;

export const TimeInput = styled(TextInput)`
  display: block;
`;
